<template>
  <div style="display: none" v-if="ready">
    <iframe ref="ssoIframe" :src="sso + '/?is_staff=1'"></iframe>
  </div>
</template>
<script>
import { login } from '@/module/service/oAuth';
import cookie from '@/module/utils/cookie';
import { domain } from '@/module/constant';
import { mapMutations } from 'vuex';
export default {
  name: 'Token',
  data() {
    return {
      sso: domain.SSO,
      ready: false
    };
  },
  methods: {
    getMessage(event) {
      // 一次性握手成功后，忽略后续任何消息，避免被翻译插件等扩展注入的污染消息再次触发跳登录
      if (this.handshaked) return;

      var origin = event.origin;
      var source = event.source;
      var data = event.data;

      // 1. origin 必须严格等于 SSO 域，过滤来自当前域 / 扩展协议（chrome-extension://）的消息
      if (origin !== this.sso) return;

      // 2. source 必须是本组件挂载的 SSO iframe，防止 SSO 同源下其他脚本（含扩展内容脚本）伪造消息
      var iframe = this.$refs.ssoIframe;
      if (!iframe || source !== iframe.contentWindow) return;

      // 3. 严格校验数据结构，过滤插件常见的字符串 / null / 异形对象消息
      if (!data || typeof data !== 'object') return;

      // 4. 仅当 res === true 且 token 是非空字符串时视为登录成功
      if (data.res === true && typeof data.token === 'string' && data.token.length > 0) {
        this.handshaked = true;
        this._saveToken(data, () => {
          this.$emit('login', data);
        });
        return;
      }

      // 5. 仅当 SSO 明确返回 res === false 时才跳登录；其他形态消息一律忽略，避免被污染消息踹下线
      if (data.res === false) {
        this.handshaked = true;
        login();
      }
    },
    _saveToken({ token, user, id, is_online, roles, departments, department_names }, cb) {
      cookie.remove('staff_token');
      cookie.set('staff_token', token);
      this.setOAuth &&
        this.setOAuth({
          user,
          userId: id,
          is_online,
          roles: roles || [],
          departments: departments || [],
          // 部门名用于按名字做权限判断（如 R&D Department）
          department_names: department_names || []
        });
      cb();
    },
    ...mapMutations('oAuth', ['setOAuth'])
  },
  mounted() {
    this.ready = true;
  },
  created() {
    // 握手状态标记，挂在实例上避免被 Vue 响应式代理
    this.handshaked = false;
    // 用 addEventListener 替代 window.onmessage = ...
    // 直接赋值的写法会被任何后注册的脚本（包括翻译扩展注入的内容脚本）整体覆盖，导致 SSO 的消息根本到不了这里
    this.boundGetMessage = this.getMessage.bind(this);
    window.addEventListener('message', this.boundGetMessage, false);
  },
  beforeDestroy() {
    if (this.boundGetMessage) {
      window.removeEventListener('message', this.boundGetMessage);
      this.boundGetMessage = null;
    }
  }
};
</script>
